import * as MutationTypes from 'store/mutation-types'

const moduleTypenameMapping = {
  Analytical: 'ParametricStudyRequest',
  Numerical: 'SimulationRequest',
  Constellations: 'Error_not_unique_constellation_typename',
  Deployment: 'DeploymentRequest',
  Defense: 'Error_not_unique_defense_typename',
  AsterX: 'Error_not_unique_asterx_typename'
}

const missionUrlMapping = {
  SimulationRequest: {
    settings: 'numericalmission',
    dashboard: 'numericaldashboard'
  },
  ManeuverRestitutionRequest: {
    settings: 'maneuverrestitutionrequest',
    dashboard: 'maneuverrestitutiondashboard'
  },
  ManeuverCatalogueAnalysisRequest: {
    settings: 'maneuveranalysisrequest',
    dashboard: 'maneuveranalysisdashboard'
  },
  DataGeneratorRequest: {
    settings: 'datageneratorrequest',
    dashboard: 'datageneratordashboard'
  },
  ScreeningCatalogueAnalysisRequest: {
    settings: 'screeningcatalogueanalysisreactivedashboard',
    dashboard: 'screeningcatalogueanalysisreactivedashboard'
  },
  EvasiveManeuverRequest: {
    settings: 'evasivemaneuverrequest',
    dashboard: 'evasivemaneuverdashboard'
  },
  ParametricStudyRequest: {
    settings: 'analyticalmission',
    dashboard: 'analyticaldashboard'
  },
  ConstellationPerformanceAnalysisRequest: {
    settings: 'analyticalconstellationsimulation',
    dashboard: 'analyticalconstellationdashboard'
  },
  ConstellationGenerationRequest: {
    settings: 'constellationgenerationmission',
    dashboard: 'constellationgenerationdashboard'
  },
  ConstellationOptimizationRequest: {
    settings: 'constellationrevisitoptimizationmission',
    dashboard: 'constellationrevisitoptimizationdashboard'
  },
  ConstellationSimulationRequest: {
    settings: 'numericalconstellationmission',
    dashboard: 'numericalconstellationdashboard'
  },
  DeploymentRequest: {
    settings: 'deploymentmission',
    dashboard: 'deploymentdashboard'
  }
}

const requiredOptionsPerMission = {
  // structure: {module:{type:requiredOptions }}
  // type: replacespace by _
  Analytical: {
    Orbital_Transfer: ['PARAMETRIC_STUDIES'],
    Orbit_Phasing: ['PARAMETRIC_STUDIES'],
    RAAN_Phasing: ['PARAMETRIC_STUDIES'],
    LEO_Station_Keeping: ['PARAMETRIC_STUDIES'],
    Deorbitation: ['PARAMETRIC_STUDIES'],
    Sequence: ['PARAMETRIC_STUDIES'],
    ADCS_Design: ['PARAMETRIC_STUDIES']
  },
  Numerical: {
    Orbital_Transfer: ['SIMULATIONS'],
    Orbit_Phasing: ['SIMULATIONS'],
    RAAN_Phasing: ['SIMULATIONS'],
    LEO_Station_Keeping: ['SIMULATIONS'],
    Spacecraft_Design_Analysis: ['SIMULATIONS'],
    Orbit_Extrapolation: ['SIMULATIONS']
  },
  Defense: {
    Simulator: ['DEFENSE'],
    Maneuver_Restitution: ['DEFENSE'],
    Maneuver_Analysis: ['DEFENSE'],
    Data_Generator: ['DEFENSE'],
    Screening: ['DEFENSE']
  },
  AsterX: { Evasive_Maneuver: ['ASTERX'] },
  Constellations: {
    Constellation: ['CONSTELLATIONS'],
    Constellation_Optimization: ['CONSTELLATIONS_ADVANCED'],
    Constellation_Generation: ['CONSTELLATIONS_ADVANCED'],
    NumericalConstellation: ['CONSTELLATIONS_ADVANCED']
  },
  Deployment: {
    Deployment_Scenario: ['DEPLOYMENT_STRATEGIES'],
    Deployment_Optimization: ['DEPLOYMENT_STRATEGIES']
  }
}

function isMissionEnabled(module, type, userOptions) {
  let requiredOptions =
    requiredOptionsPerMission[module][type.replaceAll(' ', '_')]
  if (userOptions != null) {
    if (requiredOptions != null && requiredOptions !== []) {
      for (let requiredOption of requiredOptions) {
        if (userOptions.includes(requiredOption)) {
          return true
        }
      }
      return false
    }
    return true
  }
  return false
}

function isModuleEnabled(module, userOptions) {
  let requiredOptions = module
  if (userOptions != null && userOptions.includes(requiredOptions)) {
    return true
  } else {
    return false
  }
}

function isMissionEnabledFromUrl(urlId, mission, userOptions) {
  let module = ''
  let type = ''
  switch (urlId) {
    case 'parametricstudyrequests':
      module = 'Analytical'
      type = mission.type
      break
    case 'constellationperformanceanalysisrequests':
      module = 'Constellations'
      type = 'Constellation'
      break
    case 'constellationoptimizationrequests':
      module = 'Constellations'
      type = 'Constellation Optimization'
      break
    case 'constellationgenerationrequests':
      module = 'Constellations'
      type = 'Constellation Generation'
      break
    case 'constellationsimulationrequests':
      module = 'Constellations'
      type = 'NumericalConstellation'
      break
    case 'deploymentrequests':
      module = 'Deployment'
      type = mission.type
      break
    case 'simulationrequests':
      module = 'Numerical'
      type = mission.type
      break
    case 'maneuverrestitutionrequests':
      module = 'Defense'
      type = 'Maneuver Restitution'
      break
    case 'maneuvercatalogueanalysisrequests':
      module = 'Defense'
      type = 'Maneuver Analysis'
      break
    case 'datageneratorrequests':
      module = 'Defense'
      type = 'Data Generator'
      break
    case 'evasivemaneuverrequests':
      module = 'AsterX'
      type = 'Evasive Maneuver'
      break
    case 'screeningcatalogueanalysisrequests':
      module = 'Defense'
      type = 'Screening'
      break
    default:
      module = 'Unknown module for url ' + urlId
  }
  return isMissionEnabled(module, type, userOptions)
}

const state = {
  missions: [],
  currentMission: null,
  currentResultsLog: null,
  loadingMissions: false
}

const getters = {
  currentMission(state) {
    return state.currentMission
  },
  missions(state) {
    return state.missions
  },
  currentResultsLog(state) {
    return state.currentResultsLog
  }
}

const mutations = {
  [MutationTypes.SET_CURRENT_MISSION](state, mission) {
    if (state.currentMission != null) {
      // computation might be pending
      clearInterval(state.currentMission.interval)
    }
    state.currentMission = mission
  }
}

const actions = {
  setCurrentMission({ commit }, mission) {
    if (mission) {
      localStorage.currentMissionId = `${mission.typeName}|${mission.id}`
    } else {
      localStorage.currentResultsId = null
      localStorage.currentMissionId = null
    }
    commit(MutationTypes.SET_CURRENT_MISSION, mission)
  },

  async loadMissions({ commit }, root) {
    if (state.loadingMissions) {
      return // refresh already in progress
    }
    state.loadingMissions = true

    let user = this.getters.currentUser
    state.missions = []
    if (user) {
      try {
        if ('options' in user === false) {
          await this.dispatch('loadOptions')
          user = this.getters.currentUser
        }
        let userOptions = user.options

        for (let urlId of [
          'parametricstudyrequests',
          'constellationperformanceanalysisrequests',
          'deploymentrequests',
          'simulationrequests',
          'constellationoptimizationrequests',
          'constellationgenerationrequests',
          'constellationsimulationrequests'
        ]) {
          let response = await this._vm.$http.get(`users/${user.id}/${urlId}`)
          let newData = await response.data
          // filter the missions depending on options
          newData = newData.filter((mission) =>
            isMissionEnabledFromUrl(urlId, mission, userOptions)
          )
          state.missions = [...state.missions, ...newData]
        }
      } catch (e) {
        // debug purpose
        console.log('Error : could not retrieve mission list : ', e)
        /* not useful for user + can happen when not expected
        this._vm.$notify({
          group: 'notifications',
          type: 'error',
          duration: -1,
          title: 'Error - Click to dismiss',
          text: e + ' on : Getting mission list'
        }) */
        state.missions = []
      }
    }

    state.loadingMissions = false // enable next refresh
    root.$emit('mission-list-updated')
  },

  resetResultsLog({ commit }, root) {
    state.currentResultsLog = null
    root.$emit('current-results-updated')
  },

  async loadResultsLog({ commit }, root) {
    let user = this.getters.currentUser
    if (!user) {
      state.currentResultsLog = null
      root.$emit('current-results-updated')
      return
    }
    let mission = this.getters.currentMission
    let currentResultsLog = await this.getters.currentResultsLog
    if (!mission) {
      state.currentResultsLog = null
      root.$emit('current-results-updated')
      return
    }
    if (mission && currentResultsLog) {
      if (mission.computationLogId !== currentResultsLog.id) {
        state.currentResultsLog = null
        root.$emit('current-results-updated')
      } else {
        return
      }
    }
    let computationLog
    if (mission.computationLogId === '') {
      // Workaround
      // TODO Investigate why computationLogId can be ''
      return
    }
    try {
      root.$emit('current-results-loading')
      let response = await this._vm.$http.get(
        `users/${user.id}/computationlogs/${mission.computationLogId}`
      )
      computationLog = await response.data
    } catch (e) {
      computationLog = null
      if (e.response?.status !== 404) {
        // debug purpose
        console.log('Error : could not retrieve computation log : ', e)
        /* not useful for user + can happen when not expected
              this._vm.$notify({
                group: 'notifications',
                type: 'error',
                duration: -1,
                title: 'Error - Click to dismiss',
                text: e + ' on : Getting Computation log'
              }) */
      } // error 404 is normal : does not exists
    }
    state.currentResultsLog = computationLog
    root.$emit('current-results-updated')
    return computationLog
  }
}

export default {
  state,
  mutations,
  getters,
  actions,
  isMissionEnabled,
  isModuleEnabled,
  missionUrlMapping,
  moduleTypenameMapping,

  updateAllReferences(missionType, fieldsToUpdate) {
    missionType.inputs.editing = true
    this.checkReferences(missionType, fieldsToUpdate)
  },

  checkReferences(missionType, fieldsToUpdate) {
    let missionSource = missionType.currentMission
    let missionToUpdate = missionType.inputs
    if (missionSource != null && missionToUpdate != null) {
      for (let field in missionType.getPropertiesDescription()) {
        if (missionToUpdate[field] != null) {
          if (!missionType.isExoInputMultiple(field)) {
            if (missionToUpdate[field].id != null) {
              if (
                missionSource[field] != null &&
                missionSource[field].id === missionToUpdate[field].id
              ) {
                missionToUpdate[field] = missionSource[field]
              } else {
                // the user has changed its ref without saving,
                // we need to retrieve it from the updated references
                let newIdfromCache = missionToUpdate[field].id
                for (let index = 0; index < fieldsToUpdate.length; index++) {
                  for (let item of fieldsToUpdate[index]) {
                    if (item.value.id === newIdfromCache) {
                      missionType.inputs[field] = item.value
                    }
                  }
                }
              }
            }
          } else {
            for (let i = 0; i < missionToUpdate[field].length; i++) {
              let newIdfromCache = missionToUpdate[field][i].id
              for (let index = 0; index < fieldsToUpdate.length; index++) {
                for (let item of fieldsToUpdate[index]) {
                  if (item.value.id === newIdfromCache) {
                    missionToUpdate[field][i] = item.value
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
